






import Vue from 'vue'
import AccountItem, { AccountItemProps } from './AccountItem.vue'

interface DataType {
  items: AccountItemProps[]
}

export default Vue.extend({
  name: 'Account',
  components: { AccountItem },
  data(): DataType {
    return {
      items: [
        {
          title: this.$tc('profile.title'),
          icon: { name: 'profile', type: 'custom' },
          routeName: 'Profile',
        },
        {
          title: this.$tc('creditcard.title'),
          icon: { name: 'credit-card', type: 'custom' },
          routeName: 'CreditCard',
        },
      ],
    }
  },
})
